import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListboxComponent } from './listbox/listbox.component';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { Auth0LoginComponent } from './auth0-login/auth0-login.component';
import { NfpNumbericQuestionComponent } from './questions/nfp-numberic-question/nfp-numberic-question.component';
import { NfpTextboxQuestionComponent } from './questions/nfp-textbox-question/nfp-textbox-question.component';
import { NfpDropdownQuestionComponent } from './questions/nfp-dropdown-question/nfp-dropdown-question.component';
import { RequiredAmtOrDeclineDirective } from '../validations/required-amt-or-decline.directive';
import { VinValidationWarningMessageComponent } from './vin-validation-warning-message.component';
import { NfpEffectiveDateGapWarningComponent } from './nfp-effectiveDate-gap-warning.component';
import { MessagesModule } from 'primeng/messages';
import { SelectModule } from 'primeng/select';
import { AutoFocusModule } from 'primeng/autofocus';
import { FocusTrapModule } from 'primeng/focustrap';

@NgModule({
  declarations: [
    ListboxComponent,
    Auth0LoginComponent,
    NfpNumbericQuestionComponent,
    NfpTextboxQuestionComponent,
    NfpDropdownQuestionComponent,
    RequiredAmtOrDeclineDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    CheckboxModule, 
    InputNumberModule,
    ToastModule,
    MessagesModule,
    VinValidationWarningMessageComponent,
    NfpEffectiveDateGapWarningComponent,
    SelectModule,
    AutoFocusModule,
    FocusTrapModule
  ],
  exports: [
    ListboxComponent, 
    Auth0LoginComponent,
    NfpNumbericQuestionComponent,
    NfpTextboxQuestionComponent,
    NfpDropdownQuestionComponent,
    RequiredAmtOrDeclineDirective,
    VinValidationWarningMessageComponent,
    NfpEffectiveDateGapWarningComponent
  ]
})
export class SharedComponentsModule { }